import { FC } from 'react';

import { IconProps } from '@/Atoms/Icons/Icons.type';

const ChevronIcon: FC<
  {
    className?: string;
  } & IconProps
> = ({ className, size = 30 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 21 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.62627 14.7071C7.23574 14.3166 7.23574 13.6834 7.62627 13.2929L10.9192 10L7.62627 6.70711C7.23574 6.31658 7.23574 5.68342 7.62627 5.29289C8.01679 4.90237 8.64996 4.90237 9.04048 5.29289L13.0405 9.29289C13.431 9.68342 13.431 10.3166 13.0405 10.7071L9.04048 14.7071C8.64996 15.0976 8.01679 15.0976 7.62627 14.7071Z"
      fill="#A1A1AA"
    />
  </svg>
);

export default ChevronIcon;
